import { MissionSummary } from '@edwin-group/cj-graphql';
import { Error } from '../error';
import { useMissionSummary } from './hooks/useMissionSummary';
import { MissionSummaryItem } from './components/mission-summary-item';
import { InformationCircleIcon } from '@heroicons/react/20/solid';
import { useReportingToolsStore } from '../../store/useReportingToolsStore';
import { SuspenseLoading } from '../loading';
import { useMemo } from 'react';

export const MissionSummaryComponent = () => {
  const { data, error, traitExpanded, missionSelected, setTraitExpanded, setMissionSelected, isPending } =
    useMissionSummary();
  const onOpenDialog = useReportingToolsStore((state) => state.onOpenDialog);
  const page = useReportingToolsStore((state) => state.page);

  const sortedMissionSummary = useMemo(() => {
    const missionSummary = data?.fetchReportingToolsMissionSummary?.missionSummary ?? [];

    const TRAIT_ORDER = [
      'RESILIENCE',
      'EMPATHY',
      'SELF-AWARENESS',
      'PASSION',
      'EXCELLENCE',
      'COMMUNICATION',
      'TEAMWORK',
    ];

    const getTraitRank = (trait?: string | null) => {
      if (!trait) return Number.MAX_SAFE_INTEGER;
      const rank = TRAIT_ORDER.indexOf(trait.toUpperCase());
      return rank === -1 ? Number.MAX_SAFE_INTEGER : rank;
    };

    return [...missionSummary].sort((a, b) => getTraitRank(a?.header?.trait) - getTraitRank(b?.header?.trait));
  }, [data?.fetchReportingToolsMissionSummary?.missionSummary]);

  if (error) {
    return <Error error={error} />;
  }

  return (
    <div
      className={
        (data?.fetchReportingToolsMissionSummary?.missionSummary?.length || 0) === 0
          ? 'relative overflow-hidden rounded-xl border border-gray-200 bg-white p-5 shadow-md'
          : 'relative'
      }>
      {isPending && <SuspenseLoading />}
      <div className="mb-sh-30  flex items-end justify-start gap-4">
        <h2 className="text-sh-22-28 font-medium">{page?.missionSummary?.title || ''}</h2>
        <InformationCircleIcon
          className="h-6 w-6 cursor-pointer text-gray-400"
          onClick={() =>
            onOpenDialog({
              title: page?.missionSummary?.dialogTitle || '',
              description: page?.missionSummary?.dialogDescription || '',
            })
          }
        />
      </div>

      {data?.fetchReportingToolsMissionSummary?.missionSummary?.length === 0 && (
        <div className="flex h-full flex-col items-center justify-center rounded-2xl pb-5">
          <p className="text-sh-xs text-gray-500">{page?.missionSummary?.noData || ''}</p>
        </div>
      )}

      {sortedMissionSummary.map((missionSummary) => (
        <MissionSummaryItem
          key={missionSummary?.header?.trait}
          missionSummary={missionSummary as MissionSummary}
          traitExpanded={traitExpanded}
          setTraitExpanded={setTraitExpanded}
          missionSelected={missionSelected}
          setMissionSelected={setMissionSelected}
        />
      ))}
    </div>
  );
};
